export default "__VITE_PUBLIC_ASSET__30cd846a__"